import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/actions/auth";
import Steps from "../../../components/Common/Steps";
import ProgressBar from "../../../components/ProgessBar";
import {
  CompanyInformation,
  Currency,
  EmployerInfo,
  IdentityVerification,
  PersonalInfo,
  Signature,
} from "../../../components/DraftClient";
import {
  createCompanyClient,
  createIndividualClient,
  getRejectedDraftClient,
  registerDraftClient,
  updateCompanyClient,
  updateIndividualClient,
} from "../../../redux/actions/register/draftClient";
import LoadingModal from "../../../components/Modals/LoadingModal";
import { SmallButton } from "../../../components/Buttons";
import { updateUserStatus } from "../../../redux/actions/register/updateUserStatus";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CompanyPersonalInfo from "../../../components/DraftClient/Company/CompanyPersonalInfo";
import { setPageTitle } from "../../../helper/metaDataHelper";
import ErrorMessage from "../../../components/Common/ErrorMessage";
import { GetValidationErrors } from "../../../helper";
import CreateSubAccount from "../../../components/DraftClient/CreateSubAccount";
// import SumsubKYCCheck from "../../../components/DraftClient/SumsubKYCCheck";
// import { useModules } from "../../../hooks";
// import { getModuleStatus } from "../../../redux/actions/lookups/getModuleStatus";

const getSavedState = () => {
  try {
    const saved = sessionStorage.getItem("subAccountFlow");
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    return null;
  }
};

const DraftClient = () => {
  const { user } = useSelector((state) => state.user);
  // const isSumSubEnabled = useModules("Sumsub")

  const userid = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo")).id
    : null;

  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();

  const rawSavedState = getSavedState();

  const isRejectedUpdate = location.state?.isRejectedUpdate === true;
  const rejectedSubClientId = location.state?.sub_client_id;
  const rejectedAccountType = location.state?.account_type;

  const parentClientId =
    location.state?.parentClientId || rawSavedState?.parentClientId;
  const isSubAccount =
    location.state?.isSubAccount === true ||
    rawSavedState?.isSubAccount === true;

  const getEffectiveState = () => {
    if (!rawSavedState) return null;
    if (
      rawSavedState.parentClientId &&
      parentClientId &&
      rawSavedState.parentClientId !== parentClientId
    ) {
      return null;
    }

    if (isRejectedUpdate) {
      if (rawSavedState.subAccountClientId === rejectedSubClientId) {
        return rawSavedState;
      }
      return null;
    } else {
      if (
        rawSavedState.subAccountClientId &&
        rawSavedState.step === 1 &&
        !isRejectedUpdate
      ) {
        return null;
      }

      return rawSavedState;
    }
  };
  const savedState = getEffectiveState();

  useEffect(() => {
    if (rawSavedState && !savedState) {
      sessionStorage.removeItem("subAccountFlow");
    }
  }, [rawSavedState, savedState]);

  const [subAccountClientId, setSubAccountClientId] = useState(
    savedState?.subAccountClientId || rejectedSubClientId || null,
  );
  const [subAccountUserId, setSubAccountUserId] = useState(
    savedState?.subAccountUserId || null,
  );

  const [step, setStep] = useState(
    savedState?.step || (isRejectedUpdate ? 2 : 1),
  );

  const initialIndividualFormData = {
    passport_copy: null,
    mobile_number: "",
    date_of_birth: "",
    passport_number: "",
    passport_expiry_date: "",
    nationality_id: "",
    residence_country_id: "",
    gender: "",
    mailing_address: "",
    occupation_business: "",
    job_title: "",
    employer_business_name: "",
    applicant_annual_income_usd: "",
    employer_address: "",
    selfie_photo: "",
    currency_ids: [],
    signature_photo: null,
    directors: [],
    contact_person_name: "",
    contact_person_designation: "",
    account_type: "individual",
    city: "",
    soc_code: "",
  };

  const initialCompanyFormData = {
    name: "",
    passport_copy: null,
    passport_number: "",
    dob: "",
    nationality_id: "",
    residence_country_id: "",
    passport_expiry_date: "",
    gender: "",
    contact_person_name: "",
    contact_person_designation: "",
    company_place: "",
    registration_date: "",
    business_reg_number: "",
    expiry_date: "",
    business_reg_address: "",
    nature_of_business: "",
    company_type: "",
    selfie_photo: "",
    currency_ids: [],
    directors: [],
    signature_photo: null,
    account_type: "company",
    soc_code: "",
    naics_code: "",
    company_country: "",
    company_city: "",
    tax_number: "",
  };

  const [formData, setFormData] = useState(() => {
    const type =
      rejectedAccountType ||
      savedState?.formData?.account_type ||
      (user?.account_type === "company" ? "company" : "individual");

    const baseData = {
      ...(type === "company"
        ? initialCompanyFormData
        : initialIndividualFormData),
      account_type: type,
    };

    if (savedState?.formData) {
      return { ...baseData, ...savedState.formData };
    }
    return baseData;
  });

  const activeAccountType = isSubAccount
    ? formData.account_type || "individual"
    : user.account_type;

  useEffect(() => {
    if (isSubAccount && !submissionSuccess) {
      const safeFormData = Object.keys(formData).reduce((acc, key) => {
        if (
          key !== "passport_copy" &&
          key !== "signature_photo" &&
          key !== "selfie_photo" &&
          !(formData[key] instanceof File)
        ) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});

      const stateToSave = {
        isSubAccount,
        parentClientId,
        subAccountClientId,
        subAccountUserId,
        step,
        formData: safeFormData,
      };
      sessionStorage.setItem("subAccountFlow", JSON.stringify(stateToSave));
    }
  }, [
    formData,
    step,
    isSubAccount,
    parentClientId,
    subAccountClientId,
    subAccountUserId,
    submissionSuccess,
  ]);

  const labels = isSubAccount
    ? [
        "Account Details",
        "Personal info",
        activeAccountType === "individual" ? "Employer info" : "Company",
        "Currency",
        "Required documents",
      ]
    : [
        "Personal info",
        user.account_type === "individual" ? "Employer info" : "Company",
        "Identity verification",
        "Currency",
        "Signature",
        "Required documents",
      ];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNext = () => {
    if (submissionSuccess) return;

    if (formData.selfie_photo !== "" && step === 2 && !isSubAccount) {
      setStep(step + 2); // Skip step 3
      return;
    }
    if (step < labels.length) setStep(step + 1);
  };

  const handlePrev = () => {
    if (submissionSuccess) return;
    if (step > 1) setStep(step - 1);
  };

  const isloadingModal = (status) => {
    setisLoading(status);
    setIsModalOpen(status);
  };

  const handleLogout = async () => {
    sessionStorage.removeItem("subAccountFlow");
    isloadingModal(true);
    await dispatch(logout());
    isloadingModal(false);
  };

  // this already been created in a helper folder in another branch wich will be merged
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  useEffect(() => {
    setPageTitle(`${activeAccountType} Client`);
    // dispatch(getModuleStatus({ module: "Sumsub" }));
  }, [activeAccountType]);

  useEffect(() => {
    const fetchRejectedDraftClient = async () => {
      const payload =
        isRejectedUpdate && subAccountClientId
          ? { sub_client_id: subAccountClientId }
          : {};
      if (
        (isRejectedUpdate && subAccountClientId) ||
        (!isSubAccount &&
          (user.status === "Rejected" || user.status === "Update"))
      ) {
        const res = await dispatch(getRejectedDraftClient(payload));
        if (res.status === "Rejected" || res.data) {
          const type =
            res.account_type || (res.data.company ? "company" : "individual");

          const getClientDetails = {
            individual: (res) => ({
              ...initialIndividualFormData,
              mobile_number: res.individual?.mobile_number,
              date_of_birth: formatDate(res.individual?.dob),
              passport_number: res.individual?.passport_number,
              passport_expiry_date: formatDate(
                res.individual?.passport_expiry_date,
              ),
              residence_country_id: res.individual?.residence_country_id,
              nationality_id: res.individual?.nationality_id,
              gender: res.individual?.gender,
              occupation_business:
                res.individual?.employer?.occupation_business,
              job_title: res.individual?.employer?.job_title,
              employer_business_name:
                res.individual?.employer?.employer_business_name,
              applicant_annual_income_usd:
                res.individual?.employer?.applicant_annual_income_usd,
              employer_address: res.individual?.employer?.employer_address,
              currency_ids: res.draftCurrencies || [],
              account_type: "individual",
              city: res.individual?.city,
              mailing_address: res.individual?.mailing_address,
              soc_code: res.individual?.employer?.soc_code,
            }),
            company: (res) => ({
              ...initialCompanyFormData,
              contact_person_name: res.company?.contact?.name,
              // name: res.clientName,
              passport_number: res.company?.contact?.passport_number,
              dob: formatDate(res.company?.contact?.dob),
              nationality_id: res.company?.contact?.nationality_id,
              mobile_number: res.company?.contact?.mobile_number,
              contact_person_designation: res.company?.contact?.designation,
              soc_code: res.company?.contact?.soc_code,
              passport_expiry_date: formatDate(
                res.company?.contact?.passport_expiry,
              ),
              residence_country_id: res.company?.contact?.residence_country_id,
              gender: res.company?.contact?.gender,
              company_place: res.company?.company_place,
              registration_date: formatDate(res.company?.registration_date),
              business_reg_number: res.company?.business_reg_number,
              expiry_date: formatDate(res.company?.expiry_date),
              business_reg_address: res.company?.business_reg_address,
              nature_of_business: res.company?.nature_of_business,
              company_type: res.company?.company_type,
              currency_ids: res.draftCurrencies || [],
              company_country: res.company?.company_country,
              company_city: res.company?.company_city,
              tax_number: res.company?.tax_number,
              naics_code: res.company?.naics_code,
              directors: res.directors.map((director, index) => ({
                id: index + 1,
                name: director.name,
                email: director.email,
              })),
              account_type: "company",
            }),
          };

          if (isRejectedUpdate && res.user_id) {
            setSubAccountUserId(res.user_id);
          }

          setFormData(getClientDetails[type](res.data));
        }
      }
    };

    fetchRejectedDraftClient();
  }, [dispatch, user, isRejectedUpdate, subAccountClientId]); //eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files[0]) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleCreateSubAccountDraft = async () => {
    setError("");
    setisLoading(true);

    const draftData = {
      name: formData.name,
      email_address: formData.email_address,
      mobile_number: formData.mobile_number,
      account_type: formData.account_type,
      parent_client_id: parentClientId,
      country_code_id: formData.country_code_id,
      user_id: userid,
    };

    try {
      const response = await dispatch(registerDraftClient(draftData));

      if (response && response.success) {
        setSubAccountClientId(response.sub_client_id);
        setSubAccountUserId(response.user_id);
        setisLoading(false);
        setStep(step + 1);
      } else {
        setisLoading(false);
        if (response?.errors) {
          const errorMessages = GetValidationErrors(response.errors);
          setError(errorMessages.flat().join(", "));
        } else {
          setError(response?.message || "Failed to create sub-account");
        }
      }
    } catch (e) {
      setisLoading(false);
      setError("An unexpected network error occurred.");
    }
  };

  const handleLiveness = async () => {
    const REQUEST_TIMEOUT = 60000; // 60 seconds

    try {
      const form = new FormData();
      if (isSubAccount && subAccountClientId) {
        form.append("sub_client_id", subAccountClientId);
        form.append("parent_client_id", parentClientId);
      }

      for (const key in formData) {
        if (key === "directors") {
          form.append(key, JSON.stringify(formData[key]));
        } else {
          form.append(key, formData[key]);
        }
      }
      isloadingModal(true);
      setError(""); // Clear any previous errors

      const dispatchable = {
        Update: {
          individual: (form) => updateIndividualClient(form),
          company: (form) => updateCompanyClient(form),
        },
        Draft: {
          individual: (form) => createIndividualClient(form),
          company: (form) => createCompanyClient(form),
        },
      };

      // Create a timeout promise that rejects after the specified time
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error("TIMEOUT"));
        }, REQUEST_TIMEOUT);
      });

      // Create the actual API request promise
      const statusKey = isRejectedUpdate
        ? "Update"
        : ["Draft", "Update"].includes(user.status)
          ? user.status
          : "Draft";

      const accountTypeKey = activeAccountType;

      var response = await dispatch(
        dispatchable[statusKey][accountTypeKey](form),
      );

      // Race between the request and the timeout
      response = await Promise.race([response, timeoutPromise]);

      if (response.success) {
        sessionStorage.removeItem("subAccountFlow");

        if (isSubAccount) {
          setSubmissionSuccess(true);
          setisLoading(false);
          setIsModalOpen(false);
          setSuccess(false);
          const docsStepIndex = labels.indexOf("Required documents") + 1;
          setStep(docsStepIndex);
        } else {
          setisLoading(false);
          setSuccess(true);
          setTimeout(() => {
            dispatch(updateUserStatus("Liveness Done"));
            setIsModalOpen(false);
            setSuccess(false);
            setStep(6);
            setSubmissionSuccess(true);
          }, 2000);
        }
      } else {
        isloadingModal(false);
        const responseData = response?.data || response;
        if (responseData?.errors) {
          const errorMessages = GetValidationErrors(responseData.errors);
          setError(errorMessages.flat().join(", "));
        } else {
          setError(
            responseData?.message ||
              "Internal server error, Please try again later.",
          );
        }
        const personalInfoStep = labels.indexOf("Personal info") + 1;
        if (personalInfoStep > 0) {
          setStep(personalInfoStep);
        }
      }
    } catch (error) {
      setisLoading(false);
      console.error("Error in handleLiveness:", error);

      // Handle specific error types
      if (error.message === "TIMEOUT") {
        setError(
          "Request timed out. The server is taking too long to respond. Please try again."
        );
      } else if (
        error.code === "ECONNABORTED" ||
        error.message.includes("timeout")
      ) {
        setError(
          "Connection timeout. Please check your internet connection and try again."
        );
      } else if (error.message === "Network Error" || !navigator.onLine) {
        setError(
          "Network error detected. Please check your internet connection and try again."
        );
      } else if (error.response) {
        // Server responded with an error status
        const status = error.response.status;

        if (status === 408 || status === 504 || status === 524) {
          setError("Request timed out. Please try again.");
        } else if (status >= 500 && status < 600) {
          setError("Server error occurred. Please try again later.");
        } else if (status === 413) {
          setError("Upload size too large. Please use smaller files.");
        } else if (status === 401 || status === 403) {
          setError("Authentication error. Please login again.");
        } else {
          setError(
            error.response.data?.message ||
              "An error occurred. Please try again."
          );
        }
      } else {
        setError("Something went wrong, Please try again later.");
      }
      setIsModalOpen(false);
      isloadingModal(false);
      sessionStorage.removeItem("subAccountFlow");
    }
  };

  const handleCancleSubAccount = () => {
    sessionStorage.removeItem("subAccountFlow");
    navigate("/");
  };

  const renderStepContent = (step) => {
    const currentLabel = labels[step - 1];
    switch (currentLabel) {
      case "Account Details":
        // NEW STEP 1 for Sub Accounts
        return (
          <CreateSubAccount
            formData={formData}
            onChange={onChange}
            handleCreateDraft={handleCreateSubAccountDraft}
            handleCancle={handleCancleSubAccount}
            isLoading={isLoading}
          />
        );

      case "Personal info":
        return activeAccountType === "individual" ? (
          <PersonalInfo
            handleNext={handleNext}
            formData={formData}
            onChange={onChange}
            setError={setError}
          />
        ) : (
          <CompanyPersonalInfo
            handleNext={handleNext}
            formData={formData}
            onChange={onChange}
            setError={setError}
          />
        );
      case "Employer info":
        return (
          <EmployerInfo
            handleNext={handleNext}
            handlePrev={handlePrev}
            formData={formData}
            onChange={onChange}
          />
        );
      case "Company":
        return (
          <CompanyInformation
            handleNext={handleNext}
            handlePrev={handlePrev}
            formData={formData}
            onChange={onChange}
            setError={setError}
          />
        );
      case "Identity verification":
        // return isSumSubEnabled ? (
        //   <SumsubKYCCheck handleNext={handleNext} handlePrev={handlePrev} />
        // ) : (
        return (
          <IdentityVerification
            handleNext={handleNext}
            handlePrev={handlePrev}
            formData={formData}
            setFormData={setFormData}
          />
        );
      case "Currency":
        return (
          <Currency
            handleNext={handleNext}
            handlePrev={handlePrev}
            formData={formData}
            setFormData={setFormData}
            isSubAccount={isSubAccount}
            handleLiveness={handleLiveness}
          />
        );
      case "Signature":
        return (
          <Signature
            handleNext={handleNext}
            handlePrev={handlePrev}
            setFormData={setFormData}
            formData={formData}
            onChange={onChange}
            handleLiveness={handleLiveness}
          />
        );
      case "Required documents":
        if (isSubAccount && subAccountUserId && subAccountClientId) {
          return (
            <Navigate
              to="/create-sub-account"
              state={{
                isSubAccount: true,
                sub_client_id: subAccountClientId,
                sub_user_id: subAccountUserId,
                account_type: formData.account_type,
              }}
              replace
            />
          );
        }
        return navigate("/");
      default:
        return null;
    }
  };

  return (
    <>
      <div className="md:max-w-[992px] mx-auto min-h-dvh flex-1 flex flex-col">
        <div className="inline-flex space-x-2 px-2 pb-8">
          <SmallButton onClick={handleLogout} text={"Logout"} cancel={true} />
        </div>
        <div className="flex flex-col md:items-center md:justify-center">
          <Steps step={step} labels={labels} />
          <ProgressBar step={step} labels={labels} />
        </div>

        <div className="flex flex-col md:items-center w-full px-3 justify-center md:p-6">
          {error && (
            <ErrorMessage message={error} onClose={() => setError("")} />
          )}
          <div className="py-4">{renderStepContent(step)}</div>
        </div>
      </div>
      <LoadingModal
        isLoading={isLoading}
        setisLoading={setisLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        isSuccess={isSuccess}
        setSuccess={setSuccess}
        title={"Request Submitted"}
      />
    </>
  );
};

export default DraftClient;
